module.exports = __webpack_public_path__ + "img/护理-6.9b53eadb.png";